var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"sm":"12","md":"4"}},[_c('Immediacy',{staticClass:"mb-5"}),_c('Progress',{staticClass:"mb-5"})],1),_c('v-col',{attrs:{"sm":"12","md":"8"}},[_c('Schedule',{staticClass:"mb-5"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }